export type Theme = {
    /**
     * Цвета компонентов.
     */
    color: string;

    /**
     * Общие параметры компонентов.
     */
    root: string;
};

export enum ControlSize {
    inline = 'Theme_controls_inline',
    small = 'Theme_controls_size_s',
    medium = 'Theme_controls_size_m',
    large = 'Theme_controls_size_l',
}

export const ControlSizeMapper = {
    xs: ControlSize.inline,
    s: ControlSize.small,
    m: ControlSize.medium,
    l: ControlSize.large,
};

export type GetClassesOfHrComponentsParams = {
    /**
     * Корневая тема приложения.
     */
    theme: Theme;

    /**
     * @default ControlSize.medium
     */
    controls?: ControlSize;

    /**
     * Добавляет класс с версией библиотеки
     *
     * @default true
     */
    withHrComponentsVersion?: boolean;
};

export type ConfigureRootThemeOptions = Pick<
    GetClassesOfHrComponentsParams,
    'theme' | 'controls'
> & {
    /**
     * DOM-Элемент на который должна быть установлена корневая тема.
     *
     * @default HTMLBodyElement
     */
    root?: Element | null;
};

export type SpectreColorName =
    | 'red'
    | 'orange'
    | 'green'
    | 'blue'
    | 'purple'
    | 'yellow'
    | 'indigo'
    | 'grey';
